export default "https://legacy.eskolare-development.com/images/showcase.png";